function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M11 1l-9.638 9.166a1.135 1.135 0 000 1.663L11 21"
});

function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22
  }, props), _ref);
}

export default SvgBack;